import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Amerikkalainen jalkapallo",
    Baseball: "Baseball",
    Basketball: "Koripallo",
    Boxing: "Nyrkkeily",
    Chess: "Shakki",
    Cricket: "Kriketti",
    Darts: "Darts",
    Entertainment: "Entertainment",
    "E-Sports": "E-Sports",
    Football: "Jalkapallo",
    "Formula 1": "Formula 1",
    "Gaelic Football": "Gaelilainen Jalkapallo",
    "Generic Sport": "Generic Sport",
    Golf: "Golf",
    "Greyhound Racing": "Greyhound Racing",
    Handball: "Käsipallo",
    "Ice Hockey": "Jääkiekko",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politics",
    "Rugby League": "Rugby League",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Pöytätennis",
    Tennis: "Tennis",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} voittaa",
    WinFirstRound: "{name} voittaa ensimmäisen kierroksen",
    FirstTouchdown: "{name} pisteet Touchdown ensimmäinen",
    FirstTry: "{name} pisteet Try ensimmäinen",
    TotalGoals: "{name} Maalit yhteensä",
    TotalRuns: "{name} Juoksut yhteensä",
    TotalPoints: "{name} Pisteet yhteensä",
    TopBatsman: "{name} on paras lyöjä",
    TopBowler: "{name} on paras Bowler",
    FirstScore: "{name} tekee maalin ensimmäisenä"
  },
  PromoTexts: {
    Pick: "Tee valintasi",
    Bet: "Veto",
    Pays: "Voitto"
  },
  DateTimeTexts: {
    Today: "Tänään",
    Tomorrow: "Huomenna",
    Live: "Elävä"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Tee valintasi",
    Return: "Voitto",
    Stake: "Veto",
    Draw: "X"
  },
  H2HTexts: {
    goals_scored: "Tehdyt maalit",
    shots: "Laukaukset",
    shots_on_target: "Laukaukset kohti maalia",
    ball_possession: "Pallonhallinta",
    goals_conceded: "Päästetyt maalit",
    "Per match": "Per ottelu",
    H2H: "H2H",
    W: "V",
    D: "T",
    L: "H",
    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing",
    rushing_yards_per_game: "Yards",
    rushing_touchdowns: "Touchdowns",
    rushing_percentage: "%",
    passing_stats: "Passing",
    passing_yards_per_game: "Yards",
    passing_touchdowns: "Touchdowns",
    passing_percentage: "%"
  }
};
